@if (active$ | async) {
    <app-wizard-step [title]="title" data-test="step-scan-qr">
        <ng-container *ngrxLet="stage$ as stage">
            @if (stage === 'provide-identifier') {
                <app-scan-qr
                    [allowedCodeTypes]="['site-identifier']"
                    (codeScanned)="onCodeScanned($event)"
                    (scannerUnavailable)="onScannerUnavailable()"
                />
            }
            @if (stage === 'connecting') {
                <div priva-card>
                    <priva-loader [hasFooter]="true">
                        <priva-spinner />
                        <ng-container data-footer>{{
                            'SETUP.STEP_2.CONNECTING_TO_SITE' | translate
                        }}</ng-container>
                    </priva-loader>
                </div>
            }
            @if (stage === 'error') {
                <div priva-card [hasFooter]="true" data-test="scan-site-error">
                    <priva-validation>
                        @if ((error$ | async) === 'invalid-api-version') {
                            <priva-validation-item [icon]="'fas fa-exclamation-circle'">
                                {{ 'SETUP.STEP_2.ERROR.FSP_VERSION_TOO_OLD' | translate }}
                            </priva-validation-item>
                        } @else {
                            <priva-validation-item [icon]="'fas fa-exclamation-circle'">
                                {{ 'SETUP.STEP_2.ERROR.FAIL_CONNECT_TO_SITE' | translate }}
                            </priva-validation-item>
                        }
                    </priva-validation>
                    <button
                        data-footer
                        priva-button
                        (click)="resetApiConfig()"
                        importance="primary"
                        iconClass="fas fa-arrow-rotate-right"
                        iconState="left"
                    >
                        {{ 'GENERAL.ACTION.RETRY' | translate }}
                    </button>
                </div>
            }
            @if (stage === 'provide-identifier' && !scannerAvailable) {
                <div class="camera-not-found__advanced">
                    <priva-tile
                        [isCollapsible]="true"
                        headerSize="sm"
                        size="Xs"
                        title="{{ 'SETUP.STEP_2.TITLE.ADVANCED' | translate }}"
                        [hasBody]="true"
                        [isExpanded]="isExpanded"
                        (toggleExpanded)="onToggleExpanded()"
                        [hasFooter]="true"
                        [hasDividers]="true"
                    >
                        {{ 'SETUP.STEP_2.ERROR.NO_CAMERA_FOUND' | translate }}
                        <priva-form-group [hasLabel]="true" [hasHelp]="false">
                            <ng-container data-label>{{
                                'SETUP.STEP_2.TITLE.ENTER_IDENTIFIER' | translate
                            }}</ng-container>
                            <input
                                type="text"
                                priva-input
                                placeholder="{{ 'SETUP.STEP_2.TITLE.ENTER_IDENTIFIER' | translate }}"
                                [(ngModel)]="manualIdentifier"
                                [pattern]="identifierRegex"
                                required
                                (keydown.enter)="blurIdentifierInput(); submitIdentifier(identifierNgModel)"
                                #identifierNgModel="ngModel"
                                #identifierInput
                            />
                            @if (identifierNgModel.invalid && identifierNgModel.touched) {
                                <priva-validation>
                                    <priva-validation-item [icon]="'fas fa-exclamation-circle'">
                                        {{ 'SETUP.STEP_2.ERROR.WONG_IDENTIFIER' | translate }}
                                    </priva-validation-item>
                                </priva-validation>
                            }
                        </priva-form-group>
                        <footer data-footer>
                            <button
                                priva-button
                                (click)="submitIdentifier(identifierNgModel)"
                                [isDisabled]="identifierNgModel.valid !== true"
                            >
                                {{ 'GENERAL.ACTION.SET' | translate }}
                            </button>
                        </footer>
                    </priva-tile>
                </div>
            }
        </ng-container>
    </app-wizard-step>
}
